import{getStateValue}from"@rootreeweb/zod-to-elements";import{CheckBox,CheckboxList,Input,InputFileSelect,RadioList,SelectExtended,TextArea}from"./index.js";/**
 * Returns the controls to use for a union field.
 *
 * @returns The controls to use for a union field.
 */function getUnionControls(){return[{element:CheckboxList,event:"onChange",/**
			 * Tests if the field should use this control
			 *
			 * @param f The field to test
			 * @returns If the field should use this control
			 */test:f=>{return!!(f.options&&f.settings?.isCheckBoxList)}},{element:RadioList,event:"onChange",/**
			 * Tests if the field should use this control
			 *
			 * @param f The field to test
			 * @returns If the field should use this control
			 */test:f=>{return!!(f.options&&f.settings?.isRadioList)}},{element:SelectExtended,event:"onChange",/**
			 * Tests if the field should use this control
			 *
			 * @param f The field to test
			 * @returns If the field should use this control
			 */test:f=>{return!!f.options},/**
			 * Creates additional props for the control
			 *
			 * @param f The field data
			 * @returns The additional props for the control.
			 */props:f=>{return{options:f.options}}}]}/**
 * This is the default set of controls that will be used if no custom controls
 * are provided. It is also a good starting point for creating your own custom
 * set.
 *
 * @returns A ControlLookup with the default controls.
 */export function getDefaultControls(){return{ZodString:[{element:TextArea,event:"onChange",/**
				 * Tests if the field should use this control
				 *
				 * @param f The field to test
				 * @returns If the field should use this control
				 */test:f=>!!f.settings?.textArea||!!f.settings?.isTextArea},{element:InputFileSelect,event:"onChange",/**
				 * Tests if the field should use this control
				 *
				 * @param f The field to test
				 * @returns If the field should use this control
				 */test:f=>!!f.settings?.isFileInput},{element:Input,event:"onInput"}],ZodNumber:{element:Input,event:"onInput",props:()=>{return{type:"number"}},/**
			 * Applies a transformation to the value before setting it in the state.
			 *
			 * @param e The value to transform
			 * @returns The transformed value
			 */transform:e=>Number.parseFloat(e)},ZodBoolean:{element:CheckBox,event:"onChange",/**
			 * Creates additional props for the control
			 *
			 * @param f The field data
			 * @param s The current state
			 * @returns The additional props for the control.
			 */props:(f,s)=>{if(!s)return{value:f.field};return{checked:getStateValue(f.path,s),value:f.field}}},ZodUnion:getUnionControls()}}